var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.loading
        ? _c("loader")
        : [
            _c(
              "div",
              [
                _vm.guideVisibleFirstTime
                  ? _c("info-guide", {
                      attrs: { type: "marketingBudgetExamples", visible: "" },
                      on: { click: _vm.closeInfoFirstTime },
                    })
                  : _vm._e(),
                _c("div", {
                  staticClass:
                    "d-flex justify-content-end margin-guide-not-visible",
                }),
              ],
              1
            ),
          ],
      !_vm.loading
        ? _c("marketing-costs-tabs", { staticClass: "mb-4" })
        : _vm._e(),
      _c("marketing-costs-list", {
        staticClass: "mb-4",
        attrs: { disabled: _vm.aiTemplateLoader },
      }),
      !_vm.loading
        ? _c("add-more-details", {
            attrs: {
              category: "forecast",
              step: "marketing-budget",
              "concept-name": "marketingBudgetMoreDetails",
              "completed-step-name": "marketingBudgetCompleted",
            },
          })
        : _vm._e(),
      _c("info-guide-drawer", {
        attrs: { type: "marketingBudgetExamples", visible: _vm.guideVisible },
        on: {
          close: function ($event) {
            _vm.guideVisible = false
          },
        },
      }),
      _c("ai-buddy-drawer", {
        attrs: { visible: _vm.aiBuddyDrawerVisible, type: "marketing-budget" },
        on: {
          close: function ($event) {
            _vm.aiBuddyDrawerVisible = false
          },
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }